import { render } from "./pageHeader.vue?vue&type=template&id=47425b9a"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"

import "./pageHeader.vue?vue&type=style&index=0&id=47425b9a&lang=scss"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__